// Phase 1 — HARDCODED synthetic Opportunity Intelligence Report.
// This data is fictitious. It must NEVER be replaced with real customer data.
// Per Phase 0 decision #2: hardcoded mock only.
//
// Structure mirrors the real /api/analyses response so the Sample page feels
// authentic, but every field is invented for demonstration.

export const SAMPLE_REPORT = {
  id: "sample-synthetic-demo",
  is_sample: true,
  agency: "Department of the Air Force — Air Combat Command",
  solicitation_number: "FA8773-26-R-0042 (SYNTHETIC)",
  opportunity_name: "Cyber Threat Intelligence Support Services",
  contract_type: "IDIQ — Cost-Plus-Fixed-Fee (CPFF)",
  vehicle: "GSA OASIS+ SB Pool 1",
  set_aside: "Small Business Set-Aside",
  pop: "Base year + 4 option years",
  release_date: "2026-02-12",
  questions_due: "2026-02-26",
  proposal_due: "2026-03-19",
  est_award: "2026-06-30",

  executive_summary:
    "Synthetic Phase-1 demonstration. A 5-year small-business set-aside IDIQ for "
    + "cyber threat intelligence support services at Air Combat Command. Strong fit "
    + "for SDVOSB / 8(a) cyber primes with active TS/SCI staff and prior ACC past performance.",

  scores: {
    opportunity_fit: 8,
    capability_match: 7,
    revenue_potential: 9,
    competitive_position: 6,
    compliance_burden: 7,
    resource_demand: 6,
    technical_complexity: 8,
    past_performance_alignment: 7,
    risk_profile: 5,
    win_probability: 6,
  },
  overall_score: 69,

  top_reasons_to_pursue: [
    "$48M ceiling across 5 years with steady task-order cadence at ACC.",
    "Strong fit with SDVOSB / 8(a) cyber capability statements.",
    "Section M weighs past performance 30% — our ACC TPP work is directly relevant.",
    "Vehicle (OASIS+ SB) is already on-ramped; no new contract carriage needed.",
    "Incumbent has a CPARS dispute in 2024 — open window for displacement.",
  ],
  top_risks: [
    "Compressed 35-day response window; capture team must mobilize this week.",
    "TS/SCI staffing requirement — recruiting must start before proposal kickoff.",
    "Likely 6–8 SB cyber competitors will respond; price-to-win discipline is critical.",
  ],
  hidden_red_flags: [
    "Wage determinations include a Service Contract Act area with a 14% premium over baseline.",
    "DFARS 252.204-7012 cyber compliance attestation due at proposal — not at award.",
    "Place of performance includes a remote site with no cleared facility within 30 miles.",
  ],

  outreach_angle:
    "Lead with the displaceable-incumbent angle and the SDVOSB cleared-staff bench. "
    + "Mention the matching ACC TPP past performance from FY24.",
  next_action:
    "Send capability statement + cleared-staff matrix to the ACC SBPM by Friday; "
    + "schedule a teaming call with two partners covering the 30-mile gap.",
  decision_maker:
    "ACC Small Business Professional + Cyber Branch Chief, via OASIS+ Ombudsman path.",

  recommendation: "BID WITH CAUTION",
  pursuit_recommendation: "Pursue with Caution",
};
